/* eslint-disable */
import getSessionId from '@/api/config/getSessionId'
import { useAlone } from '@/store';
import pinia from '@/store/store';
const alone = useAlone(pinia)

export const beforeEach = (to:any, from:any, next:any) => {
  localStorage.setItem('reload', '');//用来强制刷新页面的标识，''是指下次报错可以强制刷新，1是指下次有错也不能刷新
  next()
}

class BeforeGuard {
    cacheUserId: string | undefined
  
  /* 是否重定向跳转 */
  rediectPath(to:any, from:any, next:any) {
    return new Promise<void>((resolve, reject) => {
      if (to.path == from.path) {
        next(false)
        reject('反复重定向')
      }
      resolve()
    })
  }
  /* 调整参数 */
  parsePath(to:any, from:any, next:any) {
    return new Promise<void>((resolve, reject) => {
        if (to.meta?.timestamp && !to.query?.timestamp) {
            next({
                path: to.path,
                query: {
                    ...to.query,
                    timestamp: new Date().getTime()
                }
            })
            reject('调整参数')

        } else {
            resolve()
        }
    })
  }
  /* 检测登录 */
  checkLogin(to:any, from:any, next:any) {
    const sessionId_s = localStorage.getItem('sessionId')
    const handler = this.checkAloneLogin
    if (typeof handler !== 'function') {
        return Promise.reject('当前渠道登录方式未注册')
    }
    return handler.call(this, {
        sessionId_s,
        next,
        to
    })
  }

  checkAloneLogin({sessionId_s, to, next}:any) {
    return new Promise<void>(async (resolve, reject) => {
        let flag:any = !!sessionId_s
        if (!sessionId_s) {
            await getSessionId()
            if (flag) {
                if (to.path == '/login') {
                    next('/')
                    reject('当前已登录')
                } else {
                    resolve()
                }
            }else {
                // 清空用户信息
                alone.setUserInfo({})
                if (to.path != '/login') {
                    next({
                        path: '/login'
                    })
                    reject('重定向登录' + to.path)
                } else {
                    resolve()
                }
            }
        } else {
            flag = alone.getLoginStatus();
            flag.then((flag:any)=>{
                if (flag) {
                    if (to.path == '/login') {
                        next('/')
                        reject('当前已登录')
                    } else {
                        resolve()
                    }
                } else if (to.path && to.path == '/login') {
                    next()
                    reject('checkAloneLogin---重定向')
                } else {
                    // 清空用户信息
                    alone.setUserInfo({})
                    next({
                        path: '/login'
                    })
                    reject('重定向登录' + to.path)
                }
            })
        }
    })
  }

    // 检测权限
    checkPerm({to, from, next}:any) {
        return new Promise((resolve, reject) => {
            beforeEach(to, from, next)
        })
    }
}


export const beforeGuard = new BeforeGuard()